import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import Row from '@/components/common/Row'
import Text from '@/components/common/Text'
import Button from '@/components/ui/Button'

import HeaderDropdown from './common/HeaderDropdown'
import BaseLink from '@/components/common/BaseLink'
import { useRouter } from 'next/router'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { useTranslations } from 'next-intl'

const CURRENCIES = {
  USD: '$',
  EUR: '€',
  RUB: '₽',
}

const HeaderSubscription = ({ ...props }) => {
  const { referralBalance } = useSelector((store) => store.user)
  const t = useTranslations('common')
  const { locale } = useRouter()

  const referralBalanceFormatted = useMemo(
    () => referralBalance.balance + CURRENCIES[referralBalance.currency],
    [referralBalance]
  )
  const triggerText = useMemo(() => {
    return `${t('userBalanceTitle')} ${referralBalanceFormatted}`
  }, [referralBalance, locale])

  return (
    <HeaderDropdown
      triggerClickCallback={() => {
        userAmplitudeAnalytics.trackEvent('balance_status_clicked', {
          balance: referralBalanceFormatted,
        })
      }}
      isTriggerCallback={false}
      triggerText={triggerText}
      {...props}
    >
      <Row alignItems="center" justifyContent="space-between" className="mb-4">
        <Text size="14">{t('userBalanceInfo')}:</Text>
        <Text size="18" weight="500" color="blue">
          {referralBalanceFormatted}
        </Text>
      </Row>
      <Text size="14" className="mb-4">
        {t('userBalanceDescription')}.
      </Text>
      <BaseLink href="/profile/referral" isChangePath={false}>
        <Button
          onClick={() => {
            userAmplitudeAnalytics.trackEvent(
              'balance_status_details_clicked',
              {
                balance: referralBalanceFormatted,
              }
            )
          }}
          className="ml-auto"
        >
          {t('userBalanceButton')}
        </Button>
      </BaseLink>
    </HeaderDropdown>
  )
}

export default HeaderSubscription
